import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxArchive } from '@fortawesome/pro-solid-svg-icons/faBoxArchive';

import { Text, TextType } from 'ui-components/components/text';

import type { SellerTote } from '../../../../../../../pages/settings/inventory-warehouses/types';
import Global from '../../../../../../../store/global-selectors';
import { useFulfillmentPlanIdContext } from '../../../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { ToteInfoTooltip } from './tote-info-tooltip';
import { messages } from './messages';
import style from './tote-info.module.less';

export const ToteInfo = () => {
  const fulfillmentPlanId = useFulfillmentPlanIdContext();

  const fulfillmentPlan = useSelector((state) => Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId }));

  const toteId = fulfillmentPlan?.toteId;
  const pickerUserId = fulfillmentPlan?.pickerUserId;
  const processedUtc = fulfillmentPlan?.processedUtc;

  const totes = useSelector(Global.selectSellerTotes);
  const tote = totes.find((t: SellerTote) => t.toteId === toteId);

  const pickerUser = useSelector((state) => (pickerUserId ? Global.selectSellerUserById(state, { userId: pickerUserId }) : null));

  if (!toteId || !tote) {
    return null;
  }

  const pickerName = pickerUser?.name ?? null;

  return (
    <ToteInfoTooltip pickerName={pickerName} processedUtc={processedUtc}>
      <div className={style['tote-info-label']}>
        <FontAwesomeIcon className={style['tote-info-icon']} icon={faBoxArchive} />
        <Text formattedMessageValues={{ toteName: tote.toteName }} textType={TextType.Label} value={messages.toteLabel} />
      </div>
    </ToteInfoTooltip>
  );
};
